import React from 'react';
import Avatar from '@material-ui/core/Avatar';

export default function UserAvatar(props) {
    const {user, className} = props;
    return (
        <Avatar variant="circular" src={user?user.profile_pic:''} className={className}>
            {user?(user.name?user.name[0]:''):''}
        </Avatar>
    );
}
